import * as React from 'react';
export const IcIncognito = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 17h-1.11a3 3 0 00-5.63 0h-2.44a3 3 0 00-5.64 0H4a1 1 0 000 2h1.18a3 3 0 005.64 0h2.44a3 3 0 005.63 0H20a1 1 0 100-2zm1-6h-1.56l-2.51-6.75a1.94 1.94 0 00-1.2-1.16 1.82 1.82 0 00-1.56.2 5.15 5.15 0 01-4.34 0 1.82 1.82 0 00-1.56-.2 1.94 1.94 0 00-1.2 1.16L4.56 11H3a1 1 0 000 2h18a1 1 0 100-2z'
      fill='currentColor'
    />
  </svg>
);
